import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import Moment from "react-moment";
import ModalConvenioItem from "./ModalConvenioItem";
import ModalEnviarCorreo from "./ModalEnviarCorreo/ModalEnviarCorreo";
import { KTSVG } from "../../../helpers";
import "./AcreditadoInfoDetalle.css";

const InformacionAcreditados = ({ acreditadoInfo }) => {
  const [show, setShow] = useState(false);
  const [showModalCorreo, setShowModalCorreo] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  function getStatusAcreditado() {
    let clases = ["statusExpediente"];
    let labels = [];
    let Convenio = 0;
    if (String(acreditadoInfo.Demanda).toUpperCase() === "S") {
      clases.push("statisDemandaNoConvenio ");
      labels.push("Con Demanda");
    } else {
      labels.push("Sin Demanda");
    }
    if (String(acreditadoInfo.Conven).toUpperCase() === "S") {
      clases.push("statusExpedienteConvenio ");
      labels.push("Con Convenio");
      Convenio = 1;
    }
    if (acreditadoInfo.Reestruc == 1) {
      labels.push("Reestructura antes de 2017");
    }
    if (acreditadoInfo.Reestruc == 2) {
      labels.push("Reestructura de 2017 en Adel.");
    }
    if (String(acreditadoInfo.ProbRetirarse).toUpperCase() === "SI") {
      labels.push("Probable a que el credito se retire");
    }
    if (String(acreditadoInfo.CandidatoDvn).trim() != "") {
      labels.push(
        `Programa de Dscto.Vía Nómina: ` + acreditadoInfo.CandidatoDvn
      );
    }
    if (labels.length === 0) {
      return <span className="statusExpediente">Acreditado Sin demanda</span>;
    } else {
      if (Convenio == 0) {
        return <span className={clases.join(" ")}>{labels.join(" - ")}</span>;
      } else {
        return (
          <span className={clases.join(" ")} onClick={() => handleShow()}>
            {labels.join(" - ")}{" "}
          </span>
        );
      }
    }
  }

  function getUltimoPago() {
    if (acreditadoInfo.Upagomesanterior != null) {
      return (
        <p><Moment
        locale="es"
        format="DD-MMM-YYYY"
        date={acreditadoInfo.Upagomesanterior}
      /> &nbsp;&nbsp; ${acreditadoInfo.Pago} </p>

      );
      
    } else {
      return " No Hay pagos";
    }
  }
  function formatNumber(num) {
    const options2 = { style: "currency", currency: "USD" };
    const numberFormat2 = new Intl.NumberFormat("en-US", options2);
    return numberFormat2.format(num).replace("$", "");
  }
  return (
    <>
      <div className="AcreditadoInfoDetalle__container">
        <div className="AcreditadoInfoDetalle__nombre">
          {acreditadoInfo.Nombreac}
          <KTSVG
            path={"/img/Icons/Flag.svg"}
            className={`svg-icon iconFlagAcreditadoDetalle`}
          />
          <span className="lblExpediente">
            Exp. {acreditadoInfo.AcreditadoId}
          </span>
          {getStatusAcreditado()}
          <div className="AcreditadoInfoDetalle__EducacionItem">
            <button
              className="btnRegresarListado"
              onClick={() => (window.location.href = "../Acreditados")}
            >
              Regresar al Listado
            </button>

            <button
              className="btnEnviarEmail"
              onClick={() => setShowModalCorreo(true)}
            >
              Enviar Email
            </button>
          </div>
        </div>

        <div className="AcreditadoInfoDetalle__Educacion">
          <div className="AcreditadoInfoDetalle__EducacionItem">
            <KTSVG path={"/img/Icons/defaultUser.svg"} className={`svg-icon`} />
            {acreditadoInfo.Nivel}
          </div>
          <div className="AcreditadoInfoDetalle__EducacionItem">
            <KTSVG path={"/img/Icons/Maps.svg"} className={`svg-icon`} />
            {acreditadoInfo.Escuela}
          </div>
          <div className="AcreditadoInfoDetalle__EducacionItem">
            <KTSVG path={"/img/Icons/Fecha.svg"} className={`svg-icon`} />
            Asignación:{" "}
            <Moment
              locale="es"
              format="DD-MMM-YYYY"
              date={acreditadoInfo.Periodo}
            />
          </div>
          <div className="AcreditadoInfoDetalle__EducacionItem">
            <KTSVG path={"/img/Icons/Email.svg"} className={`svg-icon`} />
            {acreditadoInfo.Email}
          </div>
        </div>
        <div className="AcreditadoInfoDetalle__Deudas">
          <div className="AcreditadoInfoDetalle__DeudasItem">
            <KTSVG path={"/img/Icons/Money.svg"} className={`svg-icon Money`} />
            <span className="AcreditadoInfoDetalle__DeudasItem_Cantidad">
              {formatNumber(acreditadoInfo.CapitalVdo)}
            </span>
            <h1> Cap. Vencido</h1>
          </div>
          <div className="AcreditadoInfoDetalle__DeudasItem">
            <KTSVG path={"/img/Icons/Money.svg"} className={`svg-icon Money`} />
            <span className="AcreditadoInfoDetalle__DeudasItem_Cantidad">
              {formatNumber(acreditadoInfo.InteresVdo)}
            </span>
            <h1> int. Normal vdo</h1>
          </div>
          <div className="AcreditadoInfoDetalle__DeudasItem">
            <KTSVG path={"/img/Icons/Money.svg"} className={`svg-icon Money`} />
            <span className="AcreditadoInfoDetalle__DeudasItem_Cantidad">
              {formatNumber(acreditadoInfo.Moratorios)}
            </span>
            <h1> Int. Moratorio</h1>
          </div>

          <div className="AcreditadoInfoDetalle__DeudasItem">
            <KTSVG path={"/img/Icons/Money.svg"} className={`svg-icon Money`} />
            <span className="AcreditadoInfoDetalle__DeudasItem_Cantidad">
              {formatNumber(acreditadoInfo.GastosCob)}
            </span>
            <h1> Gtos. cobranza</h1>
          </div>
          <div className="AcreditadoInfoDetalle__DeudasItem">
            <KTSVG path={"/img/Icons/Money.svg"} className={`svg-icon Money`} />
            <span className="AcreditadoInfoDetalle__DeudasItem_Cantidad">
              {formatNumber(acreditadoInfo.SaldoDeudor)}
            </span>

            <h1> Saldo Deudor</h1>
          </div>
          <div className="AcreditadoInfoDetalle__DeudasItem">
            <KTSVG path={"/img/Icons/Money.svg"} className={`svg-icon Money`} />
            <span className="AcreditadoInfoDetalle__DeudasItem_Cantidad">
              {formatNumber(acreditadoInfo.Totalven)}
            </span>

            <h1> Total Vencido</h1>
          </div>
          <div className="AcreditadoInfoDetalle__DeudasItem">
            <KTSVG path={"/img/Icons/Money.svg"} className={`svg-icon Money`} />
            <span className="AcreditadoInfoDetalle__DeudasItem_Cantidad">
              {formatNumber(acreditadoInfo.Totxvenc)}
            </span>

            <h1> Total por vencer</h1>
          </div>
          <div className="AcreditadoInfoDetalle__DeudasItem">
            <KTSVG path={"/img/Icons/Money.svg"} className={`svg-icon Money`} />
            <span className="AcreditadoInfoDetalle__DeudasItem_Cantidad">
              {formatNumber(acreditadoInfo.Adeudototal)}
            </span>
            <h1> Total Adeudo</h1>
          </div>
        </div>
        <div className="AcreditadoInfoDetalle__Deudas2">
          <div className="AcreditadoInfoDetalle__Deudas2Item">
            <div>
              <KTSVG
                path={"/img/Menu/arr080.svg"}
                className={`svg-icon arrow`}
              />
              Mes Atraso {acreditadoInfo.Atraso}
            </div>
          </div>
          <div className="AcreditadoInfoDetalle__Deudas2Item">
            <div>
              <KTSVG
                path={"/img/Menu/arr080.svg"}
                className={`svg-icon arrow`}
              />
              Debe desde:{" "}
              <Moment
                locale="es"
                format="DD-MMM-YYYY"
                date={acreditadoInfo.DebeDesde}
              />
            </div>
          </div>
          <div className="AcreditadoInfoDetalle__Deudas2Item">
            <div>
              <KTSVG
                path={"/img/Menu/arr080.svg"}
                className={`svg-icon arrow`}
              />
              Ultimo pago: {getUltimoPago()}
            </div>
          </div>
          <div className="AcreditadoInfoDetalle__Deudas2Item">
            <div>
              <KTSVG
                path={"/img/Menu/arr080.svg"}
                className={`svg-icon arrow`}
              />
              Meses sin movimiento : {acreditadoInfo.Msinmov}
            </div>
          </div>
        </div>
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Convenio</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModalConvenioItem
            titulo={"Fecha en que inició el convenio"}
            description={
              <Moment
                className="acreditadoUltimoPago"
                locale="es"
                format="DD-MMM-YYYY"
                date={
                  acreditadoInfo.FechInicioConven != null
                    ? acreditadoInfo.FechInicioConven
                    : ""
                }
              />
            }
          />
          <ModalConvenioItem
            titulo={"Fecha de Término del convenio"}
            description={
              <Moment
                className="acreditadoUltimoPago"
                locale="es"
                format="DD-MMM-YYYY"
                date={
                  acreditadoInfo.FechTerminoConven != null
                    ? acreditadoInfo.FechTerminoConven
                    : ""
                }
              />
            }
          />
          <ModalConvenioItem
            titulo={"Importe Total"}
            description={formatNumber(acreditadoInfo.ImpteTotConven)}
          />
          <ModalConvenioItem
            titulo={"Saldo Actual"}
            description={formatNumber(acreditadoInfo.SaldoTotConven)}
          />
          <ModalConvenioItem
            titulo={"Num. de Pagos pendientes"}
            description={acreditadoInfo.NumPagosPdtes}
          />
          <ModalConvenioItem
            titulo={"Impte. Del vencimiento del Mes Actual"}
            description={formatNumber(acreditadoInfo.VtoConvenMesActual)}
          />
          <ModalConvenioItem
            titulo={"Impte. Del vencimiento del Mes siguiente"}
            description={formatNumber(acreditadoInfo.VtoConvenMesSigte)}
          />
          {acreditadoInfo.tquita != null && (
            <ModalConvenioItem
              titulo={
                "Total de Quitas pendientes de aplicar si cumple en tiempo"
              }
              description={acreditadoInfo.tquita}
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      {showModalCorreo && (
        <ModalEnviarCorreo
          show={showModalCorreo}
          setShow={setShowModalCorreo}
          acreditadoInfo={acreditadoInfo}
        />
      )}
    </>
  );
};

export default InformacionAcreditados;
